import React, {useState, useEffect} from 'react';
import '../../css/CssDoctorRegistration.css';
import favDocLogo from '../../assets/favdoctor logo 1.png';
import backGround from '../../assets/login-bg.png';
import m_background from '../../assets/mbil-service.png';
import { useStateValue } from "../../stateprovider";
import {useNavigate, Link} from "react-router-dom";
import Footer from '../../components/footer/Footer'
import Download from '../../components/download/Download'
import instance from '../../axios'
import LoginHeader from '../../components/Header/LoginHeader'



function Congratulation() {
    const [{ doctor, user }] = useStateValue();
    const[message, setMessage] = useState("");
    const[favID, setFavID] = useState("");
    const navigate = useNavigate();
    const userID = window.localStorage.getItem("userId");
    const email = window.localStorage.getItem("email");
    const staffEmail = window.localStorage.getItem("staffEmail");

    const[processing, setProcessing] = useState(false);

// useEffect(()=> {
//     const userID = window.localStorage.getItem("userId");
//     async function getFavID(){
//         await instance({
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             data: {userID: userID},
//             url: "/getFavID",
//         }).then((result)=>{
//             const favid = result.data.result.fav_id
//                 setFavID(favid);
//               //  console.log(favid);
//         }).catch(err => console.error(err))
//     }
//     if(userID !== null){
//         getFavID();
//     }else{
//         navigate('/user_signup_step_1', {options: "replace"})
//     }
// })
    const handleVerification = async() =>{
        setProcessing(true)
        await instance({
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: {email: email, userID:userID },
            url: "/verifyaccount"
        }).then((result)=>{
            if(result.data.result === "Success"){
                setMessage(result.data.message);
            }else{
                setMessage(result.data.result);
            }
        })
    }

    return (
        <div className='Congratulations'>
            <div className="DocRegMain" >

                <div className="DocRegMain__BackgroundImage">
                    <img src={backGround} alt="BackgroundImage" />
                    <img src={m_background} alt="BackgroundImage"/>

                </div>
            
              {/*  <div className="DocRegMain__Header">
                <div className="DocRegMain__Logo">
    
                <div className="Logo">
                    <center>
                        <img src={favDocLogo} className="favDocLogo" alt="favDoc Logo" />
    
                    </center>
    
                </div>
                 <div className="DocRegMain__SignButton">
               <Link to="/login"> <button>Sign-In</button></Link>
            </div> 
            </div>
    </div>*/}
    <LoginHeader />
                <div className="DocRegMain__CongratsSection">
                    {staffEmail ?
                        <div className="DocRegMain__SignUpMessage">
                            <h2><span>Thank you for showing </span><br />your interest in working with favDoctor, we will contact you shortly. </h2>

                        </div> :
                        <div className="DocRegMain__SignUpMessage">
                            <h2><span>Congratulations, {user?.user.user.firstName} </span><br />your account has been created </h2>
                            <div className='userID'>
                                <div className='favID'>Your FavID-{favID} &nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                                <path d="M10 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V8L10 1Z" stroke="#01B6E2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg></div>
                               <button className={(processing === true)? "not-allowed disabled_button" : ""} onClick={handleVerification}>Verify Your Account</button>
                               <p>{message}</p>
                            </div>
                        </div>}
                </div>
                <div className="footer">
                <Download />

                <Footer />
                </div>
               


            </div>
        </div>
    )
}
export default Congratulation;